export const messages = {
  view: {
    description: {
      id: 'admin/promotions.form.buy-and-win.benefit.gift.description',
    },
    detail: {
      active: {
        id: 'admin/promotions.form.benefit.gift.description.per-item',
      },
      inactive: {
        id: 'admin/promotions.form.benefit.gift.description.per-cart',
      },
    },
  },
  validation: {
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    required: { id: 'admin/promotions.form.validation.required' },
  },
}
